import gtag from '../analytics/gtag';
import type { Action, Params } from './ConfirmModalContent';
import { Confirm } from './Modals';

export default function showConfirmDialog(mainText: string, action?: Action): Promise<boolean>;
export default function showConfirmDialog(params: Omit<Params, 'action'>, action?: Action): Promise<boolean>;
export default function showConfirmDialog(textOrParams: string | Omit<Params, 'action'>, action?: Action): Promise<boolean> {
    if (typeof textOrParams === 'string') {
        gtag('event', 'modal_view', {
            modal_name: textOrParams,
            link_text: 'open',
        });
        return Confirm.call({ mainText: textOrParams, action }).then((result) => result ?? false);
    } else {
        gtag('event', 'modal_view', {
            modal_name: textOrParams.heading ?? textOrParams.mainText,
            link_text: 'open',
        });
        return Confirm.call({ ...textOrParams, action }).then((result) => result ?? false);
    }
}
